import { kv, setApiBaseUrl } from '@bitez/data'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { initDevTools } from './lib/dev/devTools'
import { initMeter } from './lib/meter'

import './styles/globals.css'

// Where the REST API lives. Empty in web dev — Vite proxies /api/* to :3000, so
// the SPA is same-origin with the API. Required for the Capacitor build.
setApiBaseUrl(import.meta.env.VITE_API_URL ?? '')

// Dev chrome (Impersonator) — always on under `bun dev`, opt-in via `?dev=1` in
// a build. Must run before the router reads the URL, since it strips the param.
initDevTools()

// Meui Meter — hosting-cost view counter. No-op without METER_KEY and on native.
initMeter()

// Secure Storage is async on native; hydrate before the first render so a
// logged-in user is not bounced to the login screen on every cold start.
// No-op on the web (localStorage is synchronous).
await kv.hydrate()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
